import { Button, Table } from 'antd';
import styled from 'styled-components';

const StyledTable = styled(Table)`

  button {
    margin-top: -4px;
    margin-bottom: -4px;
  }

  tbody tr {
    cursor: pointer;
    .ant-table-cell {
      transition: none !important;
    }
  }

  tbody tr:hover {
    .ant-table-cell {
      background: #ebf6ff !important;
      border-start-start-radius: 0px !important;
      border-end-start-radius: 0px !important;
    }
  }
`;

export { StyledTable }